import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import Container from './application_container';

class Error404 extends Component {
  render() {
    return (
      <Container header="Access Denied" icon="fa fa-exclamation-triangle" title="Error" subTitle="Access Denied">
        <div
          className="flex-fill"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh',
            padding: '2rem',
            animation: 'fadeIn 0.4s ease'
          }}
        >
          {/* Icon */}
          <div
            style={{
              width: 120,
              height: 120,
              borderRadius: 24,
              background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(239, 68, 68, 0.05) 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '2rem'
            }}
          >
            <i
              className="fa fa-lock"
              style={{
                fontSize: '3rem',
                color: '#EF4444'
              }}
            ></i>
          </div>

          {/* Title */}
          <h1
            style={{
              fontSize: '5rem',
              fontWeight: 800,
              color: '#6366F1',
              lineHeight: 1,
              letterSpacing: '-0.05em',
              marginBottom: '1rem'
            }}
          >
            403
          </h1>

          <h4
            style={{
              fontSize: '1.5rem',
              fontWeight: 700,
              color: '#0F172A',
              marginBottom: '0.75rem',
              letterSpacing: '-0.02em'
            }}
          >
            Access Denied
          </h4>

          <p
            style={{
              fontSize: '1rem',
              color: '#94A3B8',
              maxWidth: '400px',
              textAlign: 'center',
              marginBottom: '2rem',
              lineHeight: 1.6
            }}
          >
            Sorry, you don't have permission to access this page.
            Please contact your administrator if you believe this is a mistake.
          </p>

          {/* Action Button */}
          <Link to="/" style={{ textDecoration: 'none' }}>
            <button
              className="btn btn-primary"
              style={{
                background: 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)',
                border: 'none',
                borderRadius: '12px',
                padding: '0.875rem 2rem',
                fontSize: '1rem',
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                boxShadow: '0 4px 14px rgba(99, 102, 241, 0.3)',
                color: 'white',
                cursor: 'pointer',
                transition: 'all 200ms ease'
              }}
            >
              <i className="icon-home4"></i>
              Go to Dashboard
            </button>
          </Link>

          {/* Help Link */}
          <p
            style={{
              marginTop: '1.5rem',
              fontSize: '0.875rem',
              color: '#94A3B8'
            }}
          >
            Need help?{' '}
            <a
              href="#"
              style={{
                color: '#6366F1',
                fontWeight: 500,
                textDecoration: 'none'
              }}
            >
              Contact Support
            </a>
          </p>
        </div>
      </Container>
    );
  }
}

export default withRouter(Error404);
